/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddGroupsRequest
 */
export interface AddGroupsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AddGroupsRequest
     */
    groupIds: Array<number>;
}

/**
 * Check if a given object implements the AddGroupsRequest interface.
 */
export function instanceOfAddGroupsRequest(value: object): value is AddGroupsRequest {
    if (!('groupIds' in value) || value['groupIds'] === undefined) return false;
    return true;
}

export function AddGroupsRequestFromJSON(json: any): AddGroupsRequest {
    return AddGroupsRequestFromJSONTyped(json, false);
}

export function AddGroupsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddGroupsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupIds': json['group_ids'],
    };
}

export function AddGroupsRequestToJSON(json: any): AddGroupsRequest {
    return AddGroupsRequestToJSONTyped(json, false);
}

export function AddGroupsRequestToJSONTyped(value?: AddGroupsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_ids': value['groupIds'],
    };
}

